import * as angular from "angular";
import {Rule} from "../models/rule.model";
import {$rulesFactory} from "../$rules.factory";
import {BringozApi, BringozApiAction} from "../../persistence-layer/models/bringoz-api.model";


export class RulesRequestsService {
  constructor(private $rules: $rulesFactory, private rulesAPI: BringozApi) {
  }

  // ******************************
  // External methods
  // ******************************

  createRule(rule: Rule) {
    const api: BringozApiAction = this.rulesAPI.actions.createRule;
    return this.$$call(api, {}, rule, {});
  }

  updateRule(rule: Rule) {
    const api: BringozApiAction = this.rulesAPI.actions.updateRule;
    return this.$$call(api, {}, rule, {id: rule.id});
  }

  deleteRule(ruleId: string) {
    const api: BringozApiAction = this.rulesAPI.actions.deleteRule;
    return this.$$call(api, {}, {}, {id: ruleId});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(apiCall, params, data, options) {
    return this.$rules().$call(apiCall, params, data, options);
  }

}

angular
  .module('bringoz.admin.ruleEngine')
  .service('rulesRequestsService', RulesRequestsService);
